export class PaymentModel {
    public id: number;
    public status: number;
    //public userId: number;
    public createdAt: string;
    public cost: number;
    public email: string;
}



// WEBPACK FOOTER //
// ./src/app/core/models/payment.model.ts